import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { get } from 'lodash';

import pluralize from 'rebook/apps/utils/text/pluralize';
import * as AuthorReviewListActions from 'rebook/apps/catalog/actions/AuthorReviewListActions';
import { Author } from 'rebook/apps/catalog/models';
import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';
import BookHasNotReviews from 'rebook/apps/books/components/BookHasNotReviews';
import AuthorInformation from 'rebook/apps/base/components/AuthorInformation';
import BookListItemEmpty from 'rebook/apps/books/components/BookListItemEmpty';
import BookReview from 'rebook/apps/books/components/BookReview';

import styles from './style.scss';


class AuthorReviewListView extends React.Component {
  componentDidMount() {
    const { match, location } = this.props;
    // componentDidMount is never called server side
    // so we fetch data for client here
    this.props.AuthorReviewListActions.fetchInitialData(match, location);
  }

  componentWillUnmount() {
    this.props.AuthorReviewListActions.resetData();
  }

  static fetchInitialDataForServer(match, store) {
    return store.dispatch(AuthorReviewListActions.fetchInitialData(match));
  }

  changePage(newPageNumber) {
    window.scrollTo(0, 0);
    this.props.AuthorReviewListActions.fetchAuthorReviewList(newPageNumber);
  }

  render() {
    const { reviews, author, pageNumber, lastPageNumber } = this.props.authorReviewList;
    const theAuthor = new Author(author);

    return (
      <div className={classNames('article', 'backgroundContainer', 'themeGrey')}>
        <div className={styles.container}>
          <BreadCrumbs links={[
            { text: 'Библиотека', url: '/catalog/' },
            { text: get(author, 'cover_name', ''), url: get(author, 'absolute_url', '') },
            { text: 'Отзывы', url: '' },
          ]} />
          {author && (
            <React.Fragment>
              <div className={styles.headerTitle}>
                <h1>Отзывы на книги автора&nbsp;
                  <Link to={theAuthor.getLink()} className="link">
                    {author.cover_name}
                  </Link>
                </h1>
                <div className={styles.headerTitleReviewCount}>
                  {author.reviews_count}&nbsp;{`${pluralize(author.reviews_count, 'отзыв', 'отзывы', 'отзывов')}`}
                </div>
              </div>
              {author.reviews_count === 0
                ? (
                  <BookHasNotReviews>
                   У автора {author.cover_name} еще нет отзывов на книги
                  </BookHasNotReviews>
                )
                : (
                  <AuthorInformation
                    count={author.active_book_count}
                    authorLink={theAuthor.getLink()}
                    imageUrl={author.photo}
                    theme="noBackground"
                    name={author.cover_name} />
                )}
            </React.Fragment>
          )}
          <div className={styles.list}>
            {reviews === null
              ? [...Array(5)].map((count, key) => (
                <BookListItemEmpty key={key} />
              ))
              : reviews.map((review) => (
                <div className={styles.billetContainer} key={review.id}>
                  <div className={styles.listItem}>
                    <BookReview
                      isBookHeader
                      isAuthor
                      review={review}
                      key={review.id} />
                  </div>
                </div>
              ))
            }
          </div>
          {lastPageNumber > 1 && (
            <ContextPagination
              onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
              currentPage={pageNumber}
              lastPage={lastPageNumber} />
          )}
        </div>
      </div>
    );
  };
}

function mapStateToProps(state) {
  return {
    authorReviewList: state.authorReviewList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    AuthorReviewListActions: bindActionCreators(AuthorReviewListActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthorReviewListView);
